import { render } from "./LivraisonsCommande.vue?vue&type=template&id=324ab917"
import script from "./LivraisonsCommande.vue?vue&type=script&lang=ts"
export * from "./LivraisonsCommande.vue?vue&type=script&lang=ts"
script.render = render

export default script